/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForAssessmentRunTtlGeneration extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForAssessmentRunTtlGeneration");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForAssessmentRunTtlGeneration.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForAssessmentRunTtlGeneration>): BackgroundJobPayloadForAssessmentRunTtlGeneration {
        let obj = Object.assign(new BackgroundJobPayloadForAssessmentRunTtlGeneration(), model);
        BackgroundJobPayloadForAssessmentRunTtlGeneration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForAssessmentRunTtlGeneration>): BackgroundJobPayloadForAssessmentRunTtlGeneration {
        if (!model) return null;
        return BackgroundJobPayloadForAssessmentRunTtlGeneration.newInstance(<BackgroundJobPayloadForAssessmentRunTtlGeneration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForAssessmentRunTtlGeneration) {
        if (!obj) return;

        models.BackgroundJobPayloadForAssessmentRunTtlGeneration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForAssessmentRunTtlGeneration): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForAssessmentRunTtlGeneration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Milestone name for this ontology generation
     */
    milestone_name: string;

    framework_ids: Array<string>;

}
